import { render } from "./UserDataConfirm.vue?vue&type=template&id=5ee9b33c&scoped=true&ts=true"
import script from "./UserDataConfirm.vue?vue&type=script&lang=ts"
export * from "./UserDataConfirm.vue?vue&type=script&lang=ts"

import "./UserDataConfirm.vue?vue&type=style&index=0&id=5ee9b33c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee9b33c"]])

export default __exports__